import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "form-loading" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Loading Content", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "supporting-copy form-instructions-heading"
}
const _hoisted_4 = {
  key: 0,
  class: "supporting-copy form-instructions-heading"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.formError)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createCommentVNode(" If form does not load "),
        _createVNode($setup["formLoadError"])
      ], 64 /* STABLE_FRAGMENT */))
    : ($setup.FormState === 'Loading' || $setup.FormState === 'Setup')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Loader Dark for the form "),
          _createElementVNode("div", _hoisted_1, [
            _createVNode($setup["loaderDark"]),
            _hoisted_2
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          ($setup.CurrentMarketoFormGatingState === 'PartialGate')
            ? (_openBlock(), _createBlock($setup["resourceFormPartialGate"], _normalizeProps(_mergeProps({ key: 0 }, $setup.props)), {
                heading: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "heading", {}, () => [
                    (!$setup.resolvedDisableFormHeading)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString($setup.formHeading ? $setup.formHeading : $setup.translate("resource-forms-Heading", { ns: $setup.TranslationNamespaceEnum.formHeadingText })), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 3 /* FORWARDED */
              }, 16 /* FULL_PROPS */))
            : ($setup.CurrentMarketoFormGatingState === 'FullGate')
              ? (_openBlock(), _createBlock($setup["resourceFormFullGate"], _normalizeProps(_mergeProps({ key: 1 }, $setup.props)), {
                  heading: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "heading", {}, () => [
                      (!$setup.resolvedDisableFormHeading)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString($setup.formHeading ? $setup.formHeading : $setup.translate("resource-forms-Heading", { ns: $setup.TranslationNamespaceEnum.formHeadingText })), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 3 /* FORWARDED */
                }, 16 /* FULL_PROPS */))
              : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
}